/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Quota_Day_StartedInputs */

const fr_calendar_quota_day_started = /** @type {(inputs: Calendar_Quota_Day_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous tes cours du jour sont inclus`)
};

/**

* @param {Calendar_Quota_Day_StartedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_day_started = /** @type {((inputs?: Calendar_Quota_Day_StartedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Day_StartedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_day_started(inputs)
});